import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import {
  GRID_AREA_BADGE,
  GRID_AREA_TITLE,
  GRID_AREA_CHIP,
  GRID_AREA_HISTORY_BUTTON,
} from 'applications/GSP/pages/ParentHelper/components/Chat/components/Header/constants';

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '40px 1fr auto',
  gridTemplateAreas: `
    "${GRID_AREA_BADGE} ${GRID_AREA_TITLE} ${GRID_AREA_HISTORY_BUTTON}"
    "${GRID_AREA_BADGE} ${GRID_AREA_CHIP} ${GRID_AREA_HISTORY_BUTTON}"
   `,
  alignItems: 'center',
  padding: theme.spacing(1),
  gap: theme.spacing(1, 2),

  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(2),
    gridTemplateAreas: `"${GRID_AREA_BADGE} ${GRID_AREA_TITLE} ${GRID_AREA_CHIP}"`,
  },
}));
